import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { LeadQualificationSettingsService } from './lead-qualification-settings.service';

@Component({
  selector: 'app-lead-qualification-settings',
  templateUrl: './lead-qualification-settings.component.html',
  styleUrls: ['./lead-qualification-settings.component.scss'],
  standalone: false,
})
export class LeadQualificationSettingsComponent implements OnInit {
  private settings$ = this.leadQualificationService.settings$;
  takeActionWhenNoDupesExist$ = this.settings$.pipe(map((s) => s.createAccountGroup));
  takeActionWhenDupesExist$ = this.settings$.pipe(map((s) => s.logActivityAndReassign));

  constructor(private readonly leadQualificationService: LeadQualificationSettingsService) {}

  ngOnInit(): void {
    this.leadQualificationService.getLeadQualificationSettings();
  }

  updateNoDupesChoice(takeAction: boolean): void {
    this.leadQualificationService.setNoDupesTakeAction(takeAction);
  }

  updateDupesChoice(takeAction: boolean): void {
    this.leadQualificationService.setDupesTakeAction(takeAction);
  }
}
